import type { FC, PropsWithChildren } from 'react';

const BaseCard: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="w-full m-auto flex flex-grow flex-col md:grid grid-cols-[332px_1fr] items-center transition-all h-full md:rounded-large lg:w-[874px]">
      {children}
    </div>
  );
};

export { BaseCard };
